import { render, staticRenderFns } from "./ComoFuncionamMeuPrimeiroEmprego.vue?vue&type=template&id=193e986c&"
import script from "./ComoFuncionamMeuPrimeiroEmprego.vue?vue&type=script&lang=js&"
export * from "./ComoFuncionamMeuPrimeiroEmprego.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports